var _ellipse, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.1336,
    cy: 13.0935,
    rx: 13.1336,
    ry: 13.0935,
    fill: "#B02C17",
    fillOpacity: 0.14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1546_9705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.71729 13.4905C4.71729 13.4905 7.89148 7.14209 13.4463 7.14209C19.0012 7.14209 22.1754 13.4905 22.1754 13.4905C22.1754 13.4905 19.0012 19.8389 13.4463 19.8389C7.89148 19.8389 4.71729 13.4905 4.71729 13.4905Z",
    stroke: "#B02C17",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4466 15.8712C14.7614 15.8712 15.8272 14.8053 15.8272 13.4905C15.8272 12.1757 14.7614 11.1099 13.4466 11.1099C12.1318 11.1099 11.0659 12.1757 11.0659 13.4905C11.0659 14.8053 12.1318 15.8712 13.4466 15.8712Z",
    stroke: "#B02C17",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1546_9705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.0452,
    height: 19.0452,
    fill: "white",
    transform: "translate(3.92383 3.96777)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.9301793d44079f56589204bd7ae39d05.svg";
export { ForwardRef as ReactComponent };